module.exports = __webpack_public_path__ + "media/36.405ab554.mp3";